import { HttpService } from "core/services/http";

export class RenderCVHttpService {
    /**
     * Get list of available RenderCV templates
     */
    static async getTemplates() {
        const service = new HttpService();
        return await service.get('/rendercv/templates/', null);
    }

    /**
     * Generate a RenderCV document from user input
     * @param {Object} data - { user_info, template_id, job_info?, title? }
     */
    static async generateCV(data) {
        const service = new HttpService();
        return await service.post('/rendercv/generate/', data);
    }

    /**
     * Get list of user's RenderCV documents
     */
    static async getDocuments() {
        const service = new HttpService();
        return await service.get('/rendercv/documents/', null);
    }

    /**
     * Get a specific RenderCV document
     * @param {number} documentId 
     */
    static async getDocument(documentId) {
        const service = new HttpService();
        return await service.get(`/rendercv/documents/${documentId}/`, null);
    }

    /**
     * Update a RenderCV document
     * @param {number} documentId 
     * @param {Object} data - { yaml_content?, template_id?, title?, regenerate_pdf? }
     */
    static async updateDocument(documentId, data) {
        const service = new HttpService();
        return await service.put(`/rendercv/documents/${documentId}/`, data);
    }

    /**
     * Delete a RenderCV document
     * @param {number} documentId 
     */
    static async deleteDocument(documentId) {
        const service = new HttpService();
        return await service.delete(`/rendercv/documents/${documentId}/`);
    }

    /**
     * Download PDF file
     * @param {number} documentId 
     */
    static async downloadPDF(documentId) {
        const apiBase = HttpService.ApiBase;
        const token = HttpService.getToken();
        const url = `${apiBase}/rendercv/documents/${documentId}/pdf/`;
        
        const response = await fetch(url, {
            headers: {
                'Authorization': token ? `Bearer ${token}` : '',
            },
        });
        
        if (!response.ok) throw new Error('Failed to download PDF');
        
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `rendercv_${documentId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    }

    /**
     * Get preview data for a RenderCV document
     * @param {number} documentId 
     */
    static async getPreview(documentId) {
        const service = new HttpService();
        return await service.get(`/rendercv/documents/${documentId}/preview/`, null);
    }
}

